import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PublicRoute = ({ redireccionar }) => {
	const { token } = useSelector(state => state.auth)

	return token ? <Navigate to={redireccionar} replace /> : <Outlet />
}

export default PublicRoute
